"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var Baseline_1 = require("../model/Baseline");

var BaselineConverterImpl_1 = require("./BaselineConverterImpl");
/**
 * Baseline converter including transformation of "similar site" id to "site" id.
 * @author Radek Beran
 */


var BaselineWithReplacedSiteIdConverterImpl =
/*#__PURE__*/
function (_BaselineConverterImp) {
  _inherits(BaselineWithReplacedSiteIdConverterImpl, _BaselineConverterImp);

  function BaselineWithReplacedSiteIdConverterImpl(siteId, replaceBySiteId) {
    var _this;

    _classCallCheck(this, BaselineWithReplacedSiteIdConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaselineWithReplacedSiteIdConverterImpl).call(this));
    _this.siteId = siteId;
    _this.replaceBySiteId = replaceBySiteId;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(BaselineWithReplacedSiteIdConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var resultingSiteId = conversions.toClassReferenceId(source.siteId);
      resultingSiteId = this.siteId && this.replaceBySiteId && resultingSiteId === this.siteId ? this.replaceBySiteId : resultingSiteId;
      return new Baseline_1.Baseline(Baseline_1.Baseline.schema.id.valueOf(conversions.documentToClassId(source)), Baseline_1.Baseline.schema.externalId.valueOfField(source), Baseline_1.Baseline.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), Baseline_1.Baseline.schema.siteId.valueOf(resultingSiteId), Baseline_1.Baseline.schema.date.valueOfField(source), Baseline_1.Baseline.schema.amount.valueOfField(source), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag));
    }
  }]);

  return BaselineWithReplacedSiteIdConverterImpl;
}(BaselineConverterImpl_1.BaselineConverterImpl);

exports.BaselineWithReplacedSiteIdConverterImpl = BaselineWithReplacedSiteIdConverterImpl;